import "../trix-editor-overrides";
import '@fortawesome/fontawesome-free/js/all';

require("@rails/ujs").start();
// require("turbolinks").start()
require("@rails/activestorage").start();
require("channels");

// jQuery をグローバルに設定
import $ from 'jquery';
import 'jquery-ui/ui/widgets/autocomplete'; // jQuery UI のインポート
global.$ = global.jQuery = $;

import "./youtube_modal";


$(document).ready(function () {
  console.log('Flash element:', $('.flash').length); // .flashが存在するか確認
  $('.flash').fadeOut(4000, function () {
    console.log('Flash has faded out.'); // アニメーション終了確認
  });
});